import React,{useMemo} from 'react'
import {NavLink,Link} from 'react-router-dom'
import { HeaderPage } from '../HeaderPage'

export const LibraryHeader = ({form,osc}:Props) => {

    const newLink = useMemo(():{name:string, link:string}=>{
        if(form) return { name:"Adicionar", link:"/novo"}
        return {name:"",link:""}
    },[form])

    const ActiveClassName = useMemo(():string => {
        return 'border-b-4 text-gray-900 border-gray-900 font-bold'
    },[])
    const ClassName = useMemo(():string => {
        return 'border-b-2 text-gray-700 border-gray-600'
    },[])
     
    const renderLink = useMemo(()=>{
       if(!osc) return "/admin/biblioteca"
       return "/osc/biblioteca"
    },[osc])

    return(
        <div>
          <HeaderPage name={`${newLink.name}`} button={!osc ?
              <Link to={`/admin/biblioteca/novo`} className='bg-primary-dark py-2 px-5 rounded-md' > 
              Adicionar Item 
            </Link> 
            : undefined
            }/>
        <div className={`grid ${form ? 'grid-cols-6' : 'grid-cols-9'} mt-6`}>
            <NavLink className={ ({ isActive }) =>
              isActive ? ActiveClassName: ClassName
            } end to={`${renderLink}${newLink.link}`}>{newLink.name} Ebooks</NavLink>
            <NavLink className={({ isActive }) =>
              isActive ? ActiveClassName+' text-center': ClassName+' text-center'
            } end to={`${renderLink}${newLink.link}/dicas`}>{newLink.name} Dicas</NavLink>
            <NavLink className={({ isActive }) =>
              isActive ? ActiveClassName+' text-center': ClassName+' text-center'
            } end to={`${renderLink}${newLink.link}/videos`}>{newLink.name} Vídeos</NavLink>
            <NavLink className={({ isActive }) =>
              isActive ? ActiveClassName+' col-span-2 text-center': ClassName+' col-span-2 text-center'
            } end to={`${renderLink}${newLink.link}/material-complementar`}>{newLink.name} Material complementar</NavLink>
            <div className={`${form ? 'col-span-3':'col-span-4'} border-b-2 border-gray-600`}></div>
        </div>
        </div>
    )
}

interface Props {
    form?:boolean
    page?:string
    osc?:boolean
}